import React from 'react';

import { makeIconDef } from '../../makeIconDef';

export const HomeIconDef = {
  home: makeIconDef('home', {
    regular: () => <path fillRule="evenodd" clipRule="evenodd" d="M12 1L2 11V22H9V16C9 14.3431 10.3431 13 12 13C13.6569 13 15 14.3431 15 16V22H22V11L12 1Z" fill="currentColor" />,
  })
}